var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.589,
    height: 19.589,
    viewBox: "0 0 19.589 19.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4a87f8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.527,0H15.062a4.567,4.567,0,0,1,4.527,4.527V15.062a4.567,4.567,0,0,1-4.527,4.527H4.527A4.567,4.567,0,0,1,0,15.062V4.527A4.567,4.567,0,0,1,4.527,0ZM15.062,1.317H4.527a3.269,3.269,0,0,0-3.21,3.21V15.062a3.2,3.2,0,0,0,3.21,3.128H15.062a3.126,3.126,0,0,0,3.128-3.128V4.527A3.2,3.2,0,0,0,15.062,1.317Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48.447,68.714a.641.641,0,1,1,.905-.905l2.963,2.881,6.338-7.243c.576-.658,1.564.247.988.905L52.4,72.665Z",
    transform: "translate(-44.249 -58.015)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.18bc1ba48816665ced9b3431ed3d229b.svg";
export { ForwardRef as ReactComponent };